<template>
  <div v-if="testdrive.subscriberTableLoading">
    <loading-component class="hidden-xs"></loading-component>
  </div>
  <table v-else class="table table-striped testdrive-table">
    <thead>
      <tr>
        <th>Product</th>
        <th>First</th>
        <th>Last</th>
        <th>Email</th>
        <th>Start</th>
        <th>End</th>
        <th></th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(subscriber, index) in testdrive.subscribers" :key="index">
        <td>{{ subscriber.product_name }}</td>
        <td>{{ subscriber.first_name }}</td>
        <td>{{ subscriber.last_name }}</td>
        <td>{{ subscriber.email }}</td>
        <td>{{ subscriber.startDate }}</td>
        <td>{{ subscriber.endDate }}</td>
        <td class="text-center" style="width: 300px">
          <extend-test-drive-button
            v-if="testdrive.canExtend && subscriber.status !== 'ended'"
            :subscriber-id="subscriber.id"
            :subscriber-is-extendable="subscriber.is_extendable"
          ></extend-test-drive-button>
          <reactivate-test-drive-button
            v-if="testdrive.canReactivate && subscriber.status === 'ended'"
            :subscriber-id="subscriber.id"
          ></reactivate-test-drive-button>
          <upgrade-test-drive-button
            v-if="testdrive.canUpgrade && !subscriber.in_cart"
            :subscriber-id="subscriber.id"
          >
          </upgrade-test-drive-button>
          <remove-from-cart-button
            v-if="testdrive.canUpgrade && subscriber.in_cart"
            :subscriber-id="subscriber.id"
          ></remove-from-cart-button>
          <end-test-drive-button
            v-if="testdrive.canEnd && subscriber.status !== 'ended'"
            :subscriber-id="subscriber.id"
          ></end-test-drive-button>
          <a
            v-if="testdrive.showWelcomeKit"
            :href="subscriber.welcomekit"
            class="btn btn-xs btn-info"
            role="button"
          >
            Welcome Kit
          </a>
        </td>
      </tr>

      <tr v-if="testdrive.canCreate && addResourceBottom">
        <td colspan="11" align="center">
          <button
            class="btn btn-xs btn-primary"
            data-toggle="modal"
            data-target="#new_subscriber_modal"
          >
            New Test Drive
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import { mapState } from "vuex";
import store from "../../store/stores";
import ExtendTestDriveButton from "./ExtendTestDriveButton.vue";
import EndTestDriveButton from "./EndTestDriveButton.vue";
import UpgradeTestDriveButton from "./UpgradeTestDriveButton.vue";
import RemoveFromCartButton from "./RemoveFromCartButton.vue";
import ReactivateTestDriveButton from "./ReactivateTestDriveButton.vue";
import LoadingComponent from "../checkout/components/elements/LoadingComponent.vue";

export default {
  name: "SubscriberTable",
  components: {
    RemoveFromCartButton,
    EndTestDriveButton,
    ExtendTestDriveButton,
    UpgradeTestDriveButton,
    LoadingComponent,
    ReactivateTestDriveButton,
  },
  store,
  props: {
    addResourceBottom: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapState(["testdrive"]),
  },
};
</script>

<style scoped></style>
